import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ComponentTypeItem } from '../../../constants/component_types';

@Directive({ selector: 'schema-importer-data-preview2' })
export class SchemaImporterDataPreviewComponentWrapper extends UpgradeComponent {
  // The names of the input and output properties here must match the names of the
  // `<` and `&` bindings in the AngularJS component that is being wrapped
  @Input() data!: any;
  @Output() dataChange: EventEmitter<any>;
  @Input() component!: ComponentTypeItem;
  @Output() componentChange: EventEmitter<ComponentTypeItem>;
  @Input() options!: any;
  @Output() optionsChange: EventEmitter<any>;
  @Input() refreshData: () => {};
  @Input() isComponentPreviewer: boolean;
  @Input() isPreviewLoading: boolean;

  constructor(elementRef: ElementRef, injector: Injector) {
    // We must pass the name of the directive as used by AngularJS to the super
    super('schemaImporterDataPreview', elementRef, injector);
  }
}
